// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n  font-family: \"PingFang SC\", system-ui, -apple-system, BlinkMacSystemFont, segoe ui, Roboto, Helvetica, Arial, \"Microsoft Yahei\", sans-serif, apple color emoji, segoe ui emoji, segoe ui symbol;\n}\nimg {\n  vertical-align: middle;\n}\n.el-input__inner,\n.el-textarea__inner,\n.el-button {\n  border-radius: 0;\n}\n.clearfix::after {\n  display: table;\n  clear: both;\n  content: \"\";\n}\n.site-gray {\n  filter: grayscale(100%);\n}", ""]);
// Exports
module.exports = exports;
